<script>
import Contentstack from "contentstack";
import MegaSubMenu from "./MegaSubMenu.vue";
import TheDesktopTopMenu from "./TheDesktopTopMenu.vue";
import TheMobileTopMenu from "./TheMobileTopMenu.vue";
import TheAccountMenu from "./TheAccountMenu.vue";

export default {
  name: "TheMegaMenu",
  components: {TheMobileTopMenu, TheDesktopTopMenu, TheAccountMenu, MegaSubMenu },
  props: {
    isGuest: {
      type: Boolean,
      default: true,
    },
    path: {
      type: String,
      default: '/',
    },
    contentstackEnvironment: {
      type: String,
      default: '',
    },
    contentstackApiKey: {
      type: String,
      default: '',
    },
    contentstackDeliveryToken: {
      type: String,
      default: '',
    },
    cachedMegaMenu : {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      desktopMenuItems: {},
      mobileMenuItems: {}
    };
  },
  methods: {
    shouldPickMenu(menu) {
      if (menu.persistent) {
        return true
      }
      const startDate = new Date(menu.start_date)
      const endDate = new Date(menu.end_date)
      const now = new Date()
      return startDate <= now && endDate >= now
    },
    async fetchMegaMenuItems() {
      const megaMenuResults = this.cachedMegaMenu
      const {cta_top_nav_tier_0: ctaMenuItems, top_nav_tier_0: topMenuItems} = JSON.parse(megaMenuResults)[0][0]
      const activeTopNavItems = topMenuItems.filter(menu => this.shouldPickMenu(menu))
      return {
        ctaMenuItems,
        topMenuItems: activeTopNavItems
      }
    }
  },
  async mounted() {
    const {ctaMenuItems, topMenuItems} = await this.fetchMegaMenuItems();
    this.desktopMenuItems = {
      topMenuItems: topMenuItems.filter(menu => !menu.mobile_only),
      ctaMenuItems: ctaMenuItems.filter(menu => !menu.mobile_only)
    }
    this.mobileMenuItems = {
      topMenuItems: topMenuItems, // mobile shows all top nav items
      ctaMenuItems: ctaMenuItems.filter(menu => menu.mobile_only)
    }
  }
}
</script>

<template>
  <div class="header-menu-row w-100 page-1920">
    <the-desktop-top-menu :menu-items="desktopMenuItems"/>
    <the-mobile-top-menu :menu-items="mobileMenuItems" />
    <mega-sub-menu
        v-for="(menu, index) in mobileMenuItems.topMenuItems"
        :key="menu.menu_title_text"
        :nav="menu.navigation_reference[0]"
        :menu-idx="index + 1"/>
    <the-account-menu :is-guest="isGuest"/>
  </div>
</template>
